import { render, staticRenderFns } from "./ProgramViewPage.vue?vue&type=template&id=03aea9e5"
import script from "./ProgramViewPage.vue?vue&type=script&lang=js"
export * from "./ProgramViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports